// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { blogData } from "../Blog/BlogData";
// import { Calendar, ChevronRight, ChevronLeft } from "lucide-react";

// const Blogs = () => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const blogsPerPage = 6;

//   // Sort blogs by latest date (latest first)
//   const sortedBlogs = [...blogData].sort(
//     (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
//   );

//   // Pagination logic
//   const indexOfLastBlog = currentPage * blogsPerPage;
//   const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
//   const currentBlogs = sortedBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
//   const totalPages = Math.ceil(sortedBlogs.length / blogsPerPage);

//   // Scroll top on page change
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, [currentPage]);

//   return (
//     <div className="bg-[#fdfaf6] pt-40 pb-20 min-h-screen font-serif text-[#1a1a1a]">
//       <div className="max-w-7xl mx-auto px-6">

//         {/* Header */}
//         <div className="text-center mb-20">
//           <span className="text-[#8b5e3c] uppercase tracking-widest text-sm font-bold">
//             Legal Library
//           </span>
//           <h2 className="text-4xl md:text-5xl font-bold mt-4 italic">
//             Latest Legal Insights
//           </h2>
//           <div className="w-28 h-[2px] bg-[#8b5e3c] mx-auto mt-6"></div>
//         </div>

//         {/* Blog Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
//           {currentBlogs.map((blog) => (
//             <Link
//               to={`/blogs/${blog.id}`}
//               key={blog.id}
//               className="group bg-white border border-gray-200 shadow-md hover:shadow-lg transition-shadow duration-500 flex flex-col rounded-lg overflow-hidden"
//             >
//               {/* Image */}
//               <div className="relative h-64 overflow-hidden">
//                 <img
//                   src={blog.image}
//                   alt={blog.title}
//                   className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
//                 />

//                 {/* Category */}
//                 <div className="absolute top-4 left-4 bg-[#1a1a1a] text-[#f0e6d2] text-[10px] font-semibold px-3 py-1 tracking-wider uppercase rounded">
//                   {blog.category}
//                 </div>
//               </div>

//               {/* Content */}
//               <div className="p-6 flex flex-col flex-grow">

//                 {/* Date */}
//                 <div className="flex items-center gap-2 text-gray-500 text-[10px] mb-3 uppercase tracking-wide">
//                   <Calendar size={12} className="text-[#8b5e3c]" />
//                   {new Date(blog.date).toLocaleDateString()}
//                 </div>

//                 {/* Title */}
//                 <h3 className="text-[#1a1a1a] text-xl font-semibold mb-4 leading-snug line-clamp-2">
//                   {blog.title}
//                 </h3>

//                 {/* Excerpt */}
//                 <p className="text-gray-600 text-sm mb-6 line-clamp-3">
//                   {blog.excerpt}
//                 </p>

//                 {/* Read Button */}
//                 <div className="flex items-center gap-2 text-[#8b5e3c] text-[11px] font-semibold uppercase tracking-wide border-t border-gray-100 pt-4">
//                   Read Case Study
//                   <ChevronRight size={14} />
//                 </div>
//               </div>
//             </Link>
//           ))}
//         </div>

//         {/* Pagination */}
//         {totalPages > 1 && (
//           <div className="mt-24 flex justify-center items-center gap-3">

//             {/* Prev Button */}
//             <button
//               onClick={() =>
//                 setCurrentPage((prev) => Math.max(prev - 1, 1))
//               }
//               disabled={currentPage === 1}
//               className={`px-4 py-2 border border-[#1a1a1a] rounded transition-colors ${
//                 currentPage === 1
//                   ? "opacity-30 cursor-not-allowed"
//                   : "hover:bg-[#1a1a1a] hover:text-[#fdfaf6]"
//               }`}
//             >
//               <ChevronLeft size={18} />
//             </button>

//             {/* Page Numbers */}
//             {[...Array(totalPages)].map((_, index) => (
//               <button
//                 key={index + 1}
//                 onClick={() => setCurrentPage(index + 1)}
//                 className={`px-4 py-2 border rounded font-medium transition-all ${
//                   currentPage === index + 1
//                     ? "bg-[#1a1a1a] text-[#fdfaf6] border-[#1a1a1a]"
//                     : "bg-white text-[#1a1a1a] border-gray-300 hover:bg-[#fdfaf6] hover:border-[#8b5e3c]"
//                 }`}
//               >
//                 {index + 1}
//               </button>
//             ))}

//             {/* Next Button */}
//             <button
//               onClick={() =>
//                 setCurrentPage((prev) =>
//                   Math.min(prev + 1, totalPages)
//                 )
//               }
//               disabled={currentPage === totalPages}
//               className={`px-4 py-2 border border-[#1a1a1a] rounded transition-colors ${
//                 currentPage === totalPages
//                   ? "opacity-30 cursor-not-allowed"
//                   : "hover:bg-[#1a1a1a] hover:text-[#fdfaf6]"
//               }`}
//             >
//               <ChevronRight size={18} />
//             </button>

//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Blogs;
















import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { blogData } from "../Blog/BlogData";
import { Calendar, ChevronRight, ChevronLeft } from "lucide-react";

const Blogs = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;

  // Color Palette — matches the rest of the site
  const accentBurgundy = "#7A1F2B";
  const pureBlack = "#000000";
  const pureWhite = "#FFFFFF";

  // Sort blogs by latest date (latest first)
  const sortedBlogs = [...blogData].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  // Pagination logic
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = sortedBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(sortedBlogs.length / blogsPerPage);

  // Scroll top on page change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  return (
    <div
      className="pt-40 pb-20 min-h-screen font-serif"
      style={{ backgroundColor: pureWhite, color: pureBlack }}
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <span
            className="uppercase tracking-[0.3em] text-xs font-bold font-sans"
            style={{ color: accentBurgundy }}
          >
            Legal Library
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold mt-4"
            style={{ color: pureBlack }}
          >
            Latest <span className="italic font-light opacity-70">Legal Insights</span>
          </h2>
          <div
            className="w-20 h-[2px] mx-auto mt-6"
            style={{ backgroundColor: accentBurgundy }}
          ></div>
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
          {currentBlogs.map((blog) => (
            <Link
              to={`/blogs/${blog.id}`}
              key={blog.id}
              className="group bg-white border border-gray-200 hover:border-black transition-colors duration-500 flex flex-col"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />

                {/* Category */}
                <div
                  className="absolute top-4 left-4 text-[10px] font-semibold px-3 py-1 tracking-wider uppercase font-sans"
                  style={{ backgroundColor: pureBlack, color: pureWhite }}
                >
                  {blog.category}
                </div>
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col flex-grow">
                {/* Date */}
                <div className="flex items-center gap-2 text-gray-500 text-[10px] mb-3 uppercase tracking-wide font-sans">
                  <Calendar size={12} style={{ color: accentBurgundy }} />
                  {new Date(blog.date).toLocaleDateString()}
                </div>

                {/* Title */}
                <h3
                  className="text-xl font-bold mb-4 leading-snug line-clamp-2"
                  style={{ color: pureBlack }}
                >
                  {blog.title}
                </h3>

                {/* Excerpt */}
                <p className="text-gray-600 font-sans text-sm mb-6 line-clamp-3">
                  {blog.excerpt}
                </p>

                {/* Read Button */}
                <div
                  className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wide font-sans border-t border-gray-200 pt-4 mt-auto"
                  style={{ color: accentBurgundy }}
                >
                  Read Case Study
                  <ChevronRight size={14} />
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="mt-24 flex justify-center items-center gap-6 border-t border-gray-200 pt-10 font-sans">
            {/* Prev Button */}
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className={`flex items-center justify-center w-9 h-9 transition-colors ${
                currentPage === 1
                  ? "opacity-30 cursor-not-allowed"
                  : "hover:text-white"
              }`}
              style={{
                color: currentPage === 1 ? pureBlack : pureBlack,
              }}
              onMouseEnter={(e) => {
                if (currentPage !== 1) {
                  e.currentTarget.style.backgroundColor = pureBlack;
                  e.currentTarget.style.color = pureWhite;
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = pureBlack;
              }}
            >
              <ChevronLeft size={16} />
            </button>

            {/* Page Numbers */}
            <div className="flex items-center gap-5">
              {[...Array(totalPages)].map((_, index) => {
                const isActive = currentPage === index + 1;
                return (
                  <button
                    key={index + 1}
                    onClick={() => setCurrentPage(index + 1)}
                    className="relative pb-2 text-sm font-bold transition-colors"
                    style={{ color: isActive ? accentBurgundy : pureBlack }}
                  >
                    {index + 1}
                    {isActive && (
                      <span
                        className="absolute left-0 right-0 -bottom-0.5 h-[2px]"
                        style={{ backgroundColor: accentBurgundy }}
                      ></span>
                    )}
                  </button>
                );
              })}
            </div>

            {/* Next Button */}
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className={`flex items-center justify-center w-9 h-9 transition-colors ${
                currentPage === totalPages
                  ? "opacity-30 cursor-not-allowed"
                  : ""
              }`}
              style={{ color: pureBlack }}
              onMouseEnter={(e) => {
                if (currentPage !== totalPages) {
                  e.currentTarget.style.backgroundColor = pureBlack;
                  e.currentTarget.style.color = pureWhite;
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = pureBlack;
              }}
            >
              <ChevronRight size={16} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Blogs;